/** The fixed default worker set the cloud installer provisions.
 *
 * Ezra alone. Stacey is de-defaulted, not deleted — she is still pinned, still
 * deployable, and still on canary; she is simply not what a from-zero install
 * provisions, so she is not what this summary reports.
 *
 * Executors are deliberately absent from the reader's view: Ezra delegates to one,
 * and that is the persona's business, not a thing to hand the founder as a second
 * entity to keep track of. */
const DEFAULT_WORKERS = [
  { name: "ezra", label: "Ezra - Azure Expert", brain: "ezra-brain" },
] as const;

/**
 * The end-of-install summary `m8t bootstrap status` prints when the install lands. Pure (no I/O, no
 * colour codes) so the copy is unit-tested directly. `brainOrg` present →
 * brain-backed install (list the default workers with org-scoped brains);
 * null/undefined → a basic platform (skipped the GitHub App), so we never
 * claim agents that don't exist and point at `m8t coder deploy` instead.
 */
export function renderInstallSummary(args: { webappUrl?: string; brainOrg?: string | null }): string {
  const open = args.webappUrl ? `${args.webappUrl}        (or run: m8t open)` : "run: m8t open";
  const lines: string[] = [
    "✅ Your m8t platform is ready to use.",
    `   Open it:  ${open}`,
    "",
  ];
  if (args.brainOrg) {
    lines.push("   Your team:");
    for (const w of DEFAULT_WORKERS) {
      lines.push(`     • ${w.label}   · brain: ${args.brainOrg}/${w.brain}`);
    }
    lines.push(
      "",
      "   Reach them:  @ezra (or /ezra) in your coding agent",
      "                · the webapp  · or connect Telegram in the webapp (Channels)",
    );
  } else {
    lines.push(
      "   No brain-backed workers yet — deploy one with:  m8t coder deploy <name>   (or the m8t-architect skill)",
      "   Reach your platform via the webapp, or `m8t open`.",
    );
  }
  return lines.join("\n") + "\n";
}
